import { apiRequest } from "./apiClient";

export interface AppVersionInfo {
    version: string;
    titleEn: string;
    titleDe: string;
    bodyEn: string;
    bodyDe: string;
    publishedAt: string;
}

interface AppVersionResponse extends Partial<Omit<AppVersionInfo, "version">> {
    version: string | null;
}

/** The current admin-published version + changelog, or null if none has ever been published. */
export async function fetchCurrentAppVersion(): Promise<AppVersionInfo | null> {
    const data = await apiRequest<AppVersionResponse>("/app-version", { cache: "no-store" });
    return data.version ? (data as AppVersionInfo) : null;
}

const SEEN_KEY = "medinvoice_changelog_seen_version";

export function hasSeenChangelog(version: string): boolean {
    return localStorage.getItem(SEEN_KEY) === version;
}

export function markChangelogSeen(version: string): void {
    localStorage.setItem(SEEN_KEY, version);
}
